// AlwaysTranslateModal.tsx
// NOTE: Update frontend/src/__tests__/AlwaysTranslateModal.test.tsx and run
// `../scripts/test-frontend.sh AlwaysTranslateModal` when changing this component.
import React from 'react';
import GlossaryRuleModal from './GlossaryRuleModal';

interface AlwaysTranslateModalProps {
  seriesGlossaryStatus?: import('./hooks/useSeriesGlossary').SeriesGlossaryStatus;
  onRefreshSeriesGlossary?: () => void;
  isVisible: boolean;
  onClose: () => void;
  currentLanguagePair: string;
  alwaysTranslateWords: { [key: string]: string[] };
  seriesAlwaysTranslateWords?: { [key: string]: string[] };
  neverTranslateWords?: { [key: string]: string[] };
  seriesNeverTranslateWords?: { [key: string]: string[] };
  setAlwaysTranslateWords: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
  setSeriesTranslateRules?: React.Dispatch<
    React.SetStateAction<{
      alwaysTranslate: Record<string, string[]>;
      neverTranslate: Record<string, string[]>;
    }>
  >;
  selectedSeriesId?: string | null;
  resolvedUserId?: string;
  apiBase?: string;
  bookGuid: string;
  onSwitchRuleType?: (nextRuleType: 'always' | 'never') => void;
}

const AlwaysTranslateModal: React.FC<AlwaysTranslateModalProps> = (props) => (
  <GlossaryRuleModal ruleType="always" {...props} />
);

export default AlwaysTranslateModal;
